<template>
  <div class="color">
    <div class="color-preview" :class="{'color-preview-center': center}">
      <img v-if="selected.url && !selected.previewURL" :src="host + selected.url" alt="">
      <img v-if="selected.imageForUI" :src="host + (optionsForUiImages.find(item => item.id === selected.imageForUI)?.url)" alt="">
      <img v-else-if="selected.previewURL" :src="host + selected.previewURL" alt="">
      <div v-if="selected.hexCode" class="colorBlock" :style="{backgroundColor: selected.hexCode}"></div>
      <span>Geselecteerd:</span>
      
      <h3>{{ selected.name }}</h3>
    </div>

    <div class="color-options">
      <button v-for="(option, index) in options" :key="index" class="color-options-item" :class="selected.id == option.id ? 'color-options-item-selected' : '' " @click="changeColor(option)">
        <div class="color-options-item-image">
          <img v-if="option.url && !option.previewURL" :src="host + option.url" alt="">
          <img v-if="option.imageForUI" :src="host + (optionsForUiImages.find(item => item.id === option.imageForUI)?.url)" alt="">
          <img v-else-if="option.previewURL" :src="host + option.previewURL" alt="">
          <div v-if="option.hexCode" class="colorBlock" :style="{backgroundColor: option.hexCode}"></div>
        </div>
        <span class="color-options-item-label">{{ option.name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "color-selector-preview",

    props: {
      options: Array,
      optionsForUiImages: Array,
      selected: Object,
      center: Boolean
    },

    data () {
      return {
        host: import.meta.env.VITE_VUE_APP_TEXTURE_LOCATION,
      }
    },

    methods: {
      changeColor (color) {
        this.$emit('change', color)
      }
    }
  }
</script>

<style lang="scss" scoped>

.color {
  display: flex;
  gap: 16px;

  @media (max-width: 550px) {
    flex-wrap: wrap;
  }

  &-preview {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    max-width: 168px;

    &-center {
      & span,h3 {
        text-align: center !important;
      }
    }

    & img {
      min-height: 168px;
      min-width: 168px;
      max-height: 168px;
      max-width: 168px;
      object-fit: cover;
      border-radius: $radius-m;
      margin-bottom: 16px;
    }

    .colorBlock {
      min-height: 150px;
      min-width: 150px;
      max-height: 150px;
      max-width: 150px;
      object-fit: cover;
      border-radius: $radius-m;
    }

    & span {
      margin: 0px;
      font-weight: 500;
      color: $c-primary;
      text-align: left;
      width: 100%;
      font-size: 12px;
    }

    & h3 {
      margin: 0px;
      margin-top: -4px;
      text-align: left;
      width: 100%;
      color: $c-primary;
      font-size: 16px;
    }
  }

  &-options {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-content: flex-start;

    &-item {
      width: 120px;
      border: none;
      padding: 0px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      background-color: transparent;

      &-image {
        box-sizing: border-box;
        background-color: $c-background-1;
        border-radius: $radius-m;
        width: 120px;
        height: 120px;
        padding: 2px;
      }

      &-selected {
        & div {
          background-color: $c-secondary;
          padding: 4px;
        }

        & img {
          border-radius: $radius-m - $radius-s !important;
        }
      }

      & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: $radius-m - $radius-s/2;
        background-color: $c-background-1;
      }

      .colorBlock {
        min-width: 100px;
        min-height: 100px;
        max-width: 100px;
        max-height: 100px;
        object-fit: cover;
        border-radius: $radius-s;
      }

      &:hover > .color-options-item-hover {
        transform: translateY(-30px);
      }

      &-hover {
        position: absolute;
        bottom: -30px;
        left: 0px;
        background-color: $c-transparent-1;
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: $radius-s;
        transition: transform 175ms ease;

        &-name {
          font-weight: 500;
          padding: 5px;
          color: white;
          text-align: center;
          max-width: 100%;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

</style>